/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontTipiDomandaStato =
  (typeof GetFrontTipiDomandaStato)[keyof typeof GetFrontTipiDomandaStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontTipiDomandaStato = {
  BOZZA: 'BOZZA',
  PRONTA: 'PRONTA',
  COLLAUDO: 'COLLAUDO',
  PUBBLICATA: 'PUBBLICATA',
  APERTA: 'APERTA',
  IN_CORSO: 'IN_CORSO',
  SOSPESA: 'SOSPESA',
  ANNULLATA: 'ANNULLATA',
  CHIUSA: 'CHIUSA',
} as const;
